import { render, staticRenderFns } from "./ExitFullScreen.vue?vue&type=template&id=61a11e27&"
var script = {}
import style0 from "./ExitFullScreen.vue?vue&type=style&index=0&id=61a11e27&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports